import { render, staticRenderFns } from "./SundryItemOrdersList.vue?vue&type=template&id=3a00be99&scoped=true&"
import script from "./SundryItemOrdersList.vue?vue&type=script&lang=js&"
export * from "./SundryItemOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./SundryItemOrdersList.vue?vue&type=style&index=0&id=3a00be99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a00be99",
  null
  
)

export default component.exports